// extracted by mini-css-extract-plugin
export default {"wrapper":"vw-z","fullName":"ww-z"};